// Modal/Background overlay are on layer 2
export const Layer2 = 'z-index: 2'
// Anything that pops up and needs to show above modal should be on layer 3
export const Layer3 = 'z-index: 5'
